export default __webpack_public_path__ + "static/media/cloud.3a76f5d8.svg";